<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">申請書列印</h3>
        </div>
        <div class="modal-body send-modal-body" style="min-height: 250px;">
          <div class="font-weight-bold">申請書設有獨立條碼，為避免同一條碼重複列印，三項提醒事項：</div>
          <ol class="pl-3 sub-ol">
            <li>勿將檔案儲存或進行複製。</li>
            <li>完整產出PDF後，點選：檔案/列印，請確認『頁面處理』『份數』『1』，勿更改份數。</li>
            <li>同一檔案，勿重複進行列印動作。</li>
          </ol>
          <div class="action text-right mt-2">
            <a @click.prevent="submit('N')" class="btn btn-primary">
              列印申請書<br>(不套印客戶資料)
            </a>
            <a @click.prevent="submit('Y')" class="btn btn-primary">
              列印申請書<br>(套印客戶資料)
            </a>
          </div>
        </div>
        <form v-show="false" name='form1' :action="postUrl" method='post' target="_blank" accept-charset="big5" onsubmit="document.charset = 'big5'">
          <span>申請書編號 :  </span>
          <input name='applyNo' :value="applyNo"><br>

          <span>客戶ID :  </span>
          <input name='idno' :value="cust.id"><br>

          <span>客戶姓名 :  </span>
          <input name='name' :value="cust.name"><br>

          <span>手機 :  </span>
          <input name='mobile' :value="cust.mobile"><br>

          <span>Email :  </span>
          <input name='email' :value="cust.email"><br>

          <button type="submit" id="printSubmit">點擊送出</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { getFamilyPrint } from '@/service'

export default {
  name: 'FamilyPrintModal',
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    applyNo: {
      type: String,
      default: ''
    },
    email:{
      type: String,
      default: '' 
    }
  },
  computed : {
    ...mapGetters([ 'UserInfo' ]),
    isBox() {
     //判斷是否為box
     return this.UserInfo.userType === 'box'
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.initSend() // 初始化
      }
    },
  },
  data() {
    return {
      postUrl: '',
      cust:{},
      sendUrl: "crms/ProReport/servlet/servlets.FamilyPrint" //報表路徑
    }
  },
  methods: {
    initSend () { // 初始化
      
    },
    async submit(value) {
      if (value == "N") {
        //不套印客戶資料
        this.cust.idno = '';
        this.cust.name = '';
        this.cust.mobile = '';
        this.cust.email = '';
      } else {
        //套印客戶資料
        this.cust.idno = this.custData.id;
        this.cust.name = this.custData.name;
        this.cust.mobile = this.custData.mobile;
        this.cust.email = this.email;
      }
      this.cust.applyNo = this.applyNo || "";

      let newWindow;
      if (!this.isBox) {
        newWindow = window.open("/crm/assets/common/ajax-loader.gif");
      }
      const pdfResult = await getFamilyPrint(this.cust);

      if (this.isBox) {
        this.boxSendBase64PdfData(new Uint8Array(pdfResult.file));
      } else {        
        let file = new Blob([new Uint8Array(pdfResult.file)], {
          type: "application/pdf",
        });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, "post.pdf");
        } else {
          newWindow.location = URL.createObjectURL(file);
        }

        this.$emit("close");
      }
    }
  },
  mounted () {
    //  post網址
    'https://w3.cathaylife.com.tw/crms/ProReport/servlet/servlets.FamilyPrint'
    let href = window.location.href
    if(href.includes('://mycrm')){  // 正式環境
      this.postUrl = 'https://w3.cathaylife.com.tw/crms/ProReport/servlet/servlets.FamilyPrint'
    } else if (href.includes('://smycrm')) {  // 平測環境
      this.postUrl = 'https://sw3.cathaylife.com.tw/crms/ProReport/servlet/servlets.FamilyPrint'
    } else {  // local & 測試環境
      this.postUrl = 'https://tw3.cathaylife.com.tw/crms/ProReport/servlet/servlets.FamilyPrint'
    }
  },
}
</script>
